





















import { Component, Vue, PropSync, Prop } from 'vue-property-decorator'
import { CustomerStatuses, CustomerAccountingStatuses } from '@/modules/shared/lists'
import { AppState } from '@/stores/appStore'
import { ListsEnum } from '@/modules/shared/enums'
import { IStringIndexed } from '@/modules/shared/types'
import Customer from '@/modules/customers/models/customer'
import Rules from '@/plugins/validations'
import { mapObjectVuetifySelect } from '@/modules/shared/helpers'

@Component
export default class CustomerStatusFormFields extends Vue {
  @PropSync('customer', {
    required: true,
    default: () => new Customer()
  })
  private localCustomer!: IStringIndexed

  @Prop({ default: () => null })
  private validations!: IStringIndexed|null

  private statusTypes = mapObjectVuetifySelect(new CustomerStatuses(), true)
  private accountingStatusTypes = mapObjectVuetifySelect(new CustomerAccountingStatuses(), true)

  private get fieldRules () : IStringIndexed {
    const rules: IStringIndexed = {
      status: [Rules.required()],
      accountingStatus: [Rules.required()]
    }

    if (this.validations !== null) {
      for (const p in this.validations) {
        rules[p] = this.validations[p]
      }
    }

    return rules
  }

  public mounted () {
  }
}
